import { useEffect, useState } from 'react'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useParams } from 'react-router-dom'
import projectRolesTableAtom from '../../components/ProjectRolesTable/projectRolesTable.atom'
import projectRolesApi from '../../projectRoles.api'
import ProjectRoleSheet from '../../components/ProjectRoleSheet'
import useProjectRole from '../../hooks/useProjectRole'
import recoilStateUpdaters from 'recoil/recoil.stateUpdaters'
import eventBus from 'services/eventBus'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'

const ProjectRolePage = () => {
  const { wait, loading: updateLoading } = useHttpLoader()

  const params = useParams()
  const id = params.id
  const { projectRole, loading } = useProjectRole(id)

  const [draft, setDraft] = useState(projectRole)
  const setState = useSetRecoilState(projectRolesTableAtom)

  useEffect(() => {
    setDraft(projectRole)
  }, [projectRole])

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }
  const handleSave = () => {
    wait(projectRolesApi.update(draft, id), (resp) => {
      if (resp.status === 'success') {
        recoilStateUpdaters.itemUpdated(setState, resp.body)
        eventBus.pub('ntf.message', { type: 'info', message: 'Роль в команде обновлена' })
      }
    })
  }

  const renderContent = () => {
    if (!draft || loading) {
      return (
        <div className='flex-page-center'>
          <ThreeDotsLoader />
        </div>
      )
    }

    return (
      <>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Роль в команде</h2>
          </div>
        </div>
        <ProjectRoleSheet projectRole={draft} onChange={handleChange}>
          <Button theme='primary' loading={updateLoading} onClick={handleSave} style={{ width: 'fit-content' }}>
            Сохранить
          </Button>
        </ProjectRoleSheet>
      </>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>{renderContent()}</TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectRolePage
